<div *ngIf="showLoader">
    <span  class="loader"> 
    </span>
</div>